import { Button } from "@dropbox/dig-components/buttons";
import { Modal } from "@dropbox/dig-components/modal";
import i18n from "@mirage/translations";
import { memo } from "react";

export interface UseTemplateConfirmationModalProps {
  isOpen: boolean;
  onYes: () => void;
  onNo: () => void;
}

export const UseTemplateConfirmationModal = memo(
  ({ isOpen, onYes, onNo }: UseTemplateConfirmationModalProps) => {
    return (
      <Modal
        open={isOpen}
        withCloseButton="close"
        onRequestClose={onNo}
        isCentered
        width="small"
      >
        <Modal.Header hasBottomSpacing="title-standard">
          <Modal.Title>
            {i18n.t("use_template_confirmation_description")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body hasVerticalSpacing={true}>
          {i18n.t("use_template_confirmation_description")}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="opacity" onClick={onNo}>
            {i18n.t("tool_confirmation_dialog_no")}
          </Button>
          <Button variant="primary" onClick={onYes}>
            {i18n.t("tool_confirmation_dialog_yes")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  },
);

UseTemplateConfirmationModal.displayName = "UseTemplateConfirmationModal";
